const path = "/redux/File";
export const GET_PRESIGNED_UPLOAD_URL = `${path}/GET_PRESIGNED_UPLOAD_URL`;
export const UPLOAD_FILE = `${path}/UPLOAD_FILE`;
export const DELETE_FILE = `${path}/DELETE_FILE`;
export const UPDATE_FILES = `${path}/UPDATE_FILES`;
